import { useEffect, useState } from 'react';
import { thousandSeparator } from '../../utils/helpers'
import Pagination from '../Layout/Pagination';

const CompletedSalesTable = ({
  data,
  listedBy,
  onSelect,
  onSelectAgent
}) => {
  const [totalPur, setTotalPur] = useState(null)
  const [totalPurCase, setTotalPurCase] = useState(null)
  const [totalRent, setTotalRent] = useState(null)
  const [totalRentCase, setTotalRentCase] = useState(null)
  const [totalProj, setTotalProj] = useState(null)
  const [totalProjCase, setTotalProjCase] = useState(null)
  const [totalCase, setTotalCase] = useState(null)
  const [totalComm, setTotalComm] = useState(null)
  const [totalAgent, setTotalAgent] = useState(null)
  const [totalActAgent, setTotalActAgent] = useState(null)
  const [totalSusAgent, setTotalSusAgent] = useState(null)

  const [currentPage, setCurrentPage] = useState(1);

  const handleSelect = (item, caseType) => {
    onSelect(item, caseType)
  }

  const handleSelectAgent = (item) => {
    onSelectAgent(item)
  }

  const ITEMS_PER_PAGE = 10;

  const paginatedData = () => {
    const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIdx = startIdx + ITEMS_PER_PAGE;
    return data.slice(startIdx, endIdx);
  };

  useEffect(() => {
    if (data) {
      const totalPur = data.reduce((acc, item) => acc + item.TotalPurComm, 0);
      const totalPurCase = data.reduce((acc, item) => acc + item.TotalPurCase, 0);
      const totalRent = data.reduce((acc, item) => acc + item.TotalRentComm, 0);
      const totalRentCase = data.reduce((acc, item) => acc + item.TotalRentCase, 0);
      const totalProj = data.reduce((acc, item) => acc + item.TotalDeveloperSalesComm, 0);
      const totalProjCase = data.reduce((acc, item) => acc + item.TotalDeveloperSalesCase, 0);
      const totalCase = data.reduce((acc, item) => acc + item.TotalCase, 0);
      const totalComm = data.reduce((acc, item) => acc + item.TotalCommission, 0);
      const totalAgent = data.reduce((acc, item) => acc + item.TotalAgent, 0);
      const totalActAgent = data.reduce((acc, item) => acc + item.TotalActiveAgent, 0);
      const totalSusAgent = data.reduce((acc, item) => acc + item.TotalSuspendedAgent, 0);

      setTotalPur(totalPur)
      setTotalPurCase(totalPurCase)
      setTotalRent(totalRent)
      setTotalRentCase(totalRentCase)
      setTotalProj(totalProj)
      setTotalProjCase(totalProjCase)
      setTotalCase(totalCase)
      setTotalComm(totalComm)
      setTotalAgent(totalAgent)
      setTotalActAgent(totalActAgent)
      setTotalSusAgent(totalSusAgent)
    }
  }, [data])

  return (
    <>
      <div className='flex flex-col gap-1'>
        <div className='mb-1 flex items-center justify-between'>
          <p className='font-semibold text-gray-one uppercase'>Completed Sales - { listedBy } Performance</p>
        </div>

        <div className='border-border border rounded-[10px] shadow-md overflow-hidden flex-1 relative'>
          <div className='w-full h-full overflow-scroll hide-scrollbar bg-gray-200'>
            <div className="md:w-full w-[1080px] h-full">
              <table className="w-full border-collapse bg-white">
                <thead className="border-b border-gray-200 bg-gray-200 text-gray-one sticky top-0">
                  <tr>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      #
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-start">
                      { listedBy } Name
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Purchase (RM)
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Total Purchase Case
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Rent (RM)
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Total Rent Case
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Project (RM)
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Total Project Case
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Total Case
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Total Commission (RM)
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Total Agent Recruit
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Total Active Agent Recruit
                    </th>
                    <th scope="col" className="text-[11px] font-semibold px-3 py-2 whitespace-nowrap text-center">
                      Total Suspended Agent Recruit
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData().map((item, idx) => (
                    <tr key={ 'sales_' + idx } className="border-gray-200 border-b text-gray-two group hover:bg-gray-50">
                      <td className="px-3 py-2 border-r whitespace-nowrap text-xs font-medium text-center">{ idx + 1 }</td>
                      <td onClick={ () => handleSelect(item, null) } className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-start text-primary hover:text-orange cursor-pointer">{ item.CommissionPayToUserBranch }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center">{ thousandSeparator(item.TotalPurComm)  }</td>
                      <td onClick={ () => handleSelect(item, 'Purchase') } className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center text-primary hover:text-orange cursor-pointer">{ item.TotalPurCase  }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center">{ thousandSeparator(item.TotalRentComm)  }</td>
                      <td onClick={ () => handleSelect(item, 'Rent') } className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center text-primary hover:text-orange cursor-pointer">{ item.TotalRentCase  }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center">{ thousandSeparator(item.TotalDeveloperSalesComm)  }</td>
                      <td onClick={ () => handleSelect(item, 'DeveloperSales') } className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center text-primary hover:text-orange cursor-pointer">{ item.TotalDeveloperSalesCase  }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center">{ item.TotalCase  }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center">{ thousandSeparator(item.TotalCommission)  }</td>
                      <td onClick={ () => handleSelectAgent(item) }  className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center text-primary hover:text-orange cursor-pointer">{ item.TotalAgent  }</td>
                      <td className="text-xs font-normal px-3 py-2 border-r whitespace-nowrap text-center">{ item.TotalActiveAgent  }</td>
                      <td className="text-xs font-normal px-3 py-2 whitespace-nowrap text-center">{ item.TotalSuspendedAgent  }</td>
                    </tr>
                  ))}
                  <tr className="border-gray-200 text-gray-one bg-gray-100 sticky bottom-0">
                      <td colSpan={2} className="px-3 py-2 border-r whitespace-nowrap text-xs font-semibold text-end">Total:</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ thousandSeparator(totalPur ?? 0) }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ totalPurCase ?? 0 }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ thousandSeparator(totalRent ?? 0) }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ totalRentCase ?? 0 }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ thousandSeparator(totalProj ?? 0) }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ totalProjCase ?? 0 }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ totalCase ?? 0 }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ thousandSeparator(totalComm ?? 0) }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ totalAgent ?? 0 }</td>
                      <td className="text-xs font-medium px-3 py-2 border-r whitespace-nowrap text-center">{ totalActAgent ?? 0 }</td>
                      <td className="text-xs font-medium px-3 py-2 whitespace-nowrap text-center">{ totalSusAgent ?? 0 }</td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Pagination
          data={ data }
          currentPage={ currentPage }
          setCurrentPage={ setCurrentPage }
          perPage={ ITEMS_PER_PAGE }
        />
      </div>
    </>
  )
}

export default CompletedSalesTable